const initialState = {
  token: null,
  admindata:null
};
// Either fix the reducer:
const authReducer = (state = initialState, action) => {


  switch (action.type) {
    case "SET_REGTOKEN": // Updated from SET_TOKEN
      return {
        ...state,
        token: action.payload.token,
      };
    case "SET_ADMIN_DATA":
      return {
        ...state,
        admindata: action.payload.admindata,
      };
    default:
      return state;
  }
};

export default authReducer;
